export default __webpack_public_path__ + "static/preview-005b6a938f1523ec654fe9b6fd910873.jpg";